/**
 * 视频信息
 */

import {POST, GET} from './service.config.js'
import { codePointAt } from 'core-js/fn/string';


/**
 * 获取视频列表
 * @param userId
 * @param page
 * @param limit
 * @returns {Promise | Promise<unknown>}
 */
export const getVideoListService = (userId,page,limit,code,typeId) => POST('btrbasic/getViodeos',{
    user_id : userId || 0,
    page,
    limit,
    search:code,
    category_id:typeId,
});

/**
 * 获取视频列表
 * @param userId
 * @param page
 * @param limit
 * @returns {Promise | Promise<unknown>}
 */
export const delVideoService = (id) => POST('btrbasic/delVideo',{
    id
});


/**
 * 获取我喜欢的视频
 * @param userId
 * @param page
 * @param limit
 * @returns {Promise | Promise<unknown>}
 */
export const getLikeVideoListService = (userId,page,limit) => POST('btrbasic/getMyLikeVideo',{
    user_id:userId ,
    page,
    limit,
});


/**
 * 设置喜欢的视频
 * @param userId
 * @param videoId
 * @returns {Promise | Promise<unknown>}
 */
export const setLikeVideoService = (userId,videoId) => POST('btrbasic/videoLike',{
    video_id:videoId,
    user_id:userId
});


/**
 * 获取视频详细信息
 * @param userId
 * @param videoId
 * @returns {Promise | Promise<unknown>}
 */
export const getVideoDetailsService = (userId,videoId,type) => POST('btrbasic/getVideoDetail',{
    user_id:userId || 0,
    video_id:videoId,
    next:type,
});

/**
 * 获取商家视频列表
 * @param userId
 * @param page
 * @param limit
 * @returns {Promise | Promise<unknown>}
 */
export const getShopVideoListService = (lat,lng,page,limit,search,typeId) => POST('btrbasic/getShopVideos',{
    lat,
	lng,
    page,
    limit,
    search,
	typeId
});

/**
 * 获取商家视频详细信息
 * @param userId
 * @param videoId
 * @returns {Promise | Promise<unknown>}
 */
export const getShopVideoDetailsService = (userId,videoId,type) => POST('btrbasic/getShopVideoDetail',{
    user_id:userId || 0,
    video_id:videoId,
    next:type,
});

